const updates = [
  {
    date: '2026.07.31',
    title: '星辰大海大结局上线',
    desc: '年度科幻巨制《星辰大海》迎来大结局，全网首播独家上线天狼影院，48集完整版一次看够。',
  },
  {
    date: '2026.07.30',
    title: '播放体验全面升级',
    desc: '天狼影院完成CDN节点扩容，全国范围内观影流畅度提升40%，4K画质加载速度再创新高。',
  },
  {
    date: '2026.07.28',
    title: '韩剧频道重磅更新',
    desc: '新增15部高分韩剧资源，涵盖悬疑、爱情、奇幻多种类型，全部支持1080P高清播放。',
  },
  {
    date: '2026.07.25',
    title: '综艺频道暑期特辑上线',
    desc: '欢乐喜剧人第八季、极限挑战巅峰季等热门综艺完整合集上线，暑期欢乐不间断。',
  },
  {
    date: '2026.07.22',
    title: '纪录片频道全新改版',
    desc: '纪录片频道界面改版完成，按自然、人文、科技分类，精选100+部高分纪录片。',
  },
  {
    date: '2026.07.18',
    title: '暗夜追光播放量破30亿',
    desc: '悬疑剧《暗夜追光》全网点播量突破30亿次，成为年度现象级国产悬疑剧新标杆。',
  },
  {
    date: '2026.07.15',
    title: '动漫频道暑期档开启',
    desc: '山海传说领衔暑期档动漫盛宴，新增50+部国产原创动画和日本热门番剧资源。',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500">天狼影院最新资讯与更新公告</p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300 hidden sm:block"></div>
          <div className="space-y-5">
            {updates.map((update, i) => (
              <div key={i} className="flex gap-4 sm:gap-6">
                <div className="hidden sm:flex flex-col items-center pt-1">
                  <div className="w-[10px] h-[10px] rounded-full bg-primary-500 flex-shrink-0 relative z-10"></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-lg p-4 border border-background-200">
                  <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded mb-2">
                    {update.date}
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{update.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{update.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}